/**
 * youtube helpers
 */
class Youtube {

	/**
	 * returns the internal proxy cache thumb url according to the given parameters.
	 *
	 * @param appConfig 		object - actual appConfig
	 * @param storage 			object - actual storage
	 * @param id				string - video id
	 * @param [thumbQuality]	string - thumb quality - default is set via serverAppConfig.proxyCaches.services.youtube.defaultThumbQuality
	 * @return {string}			maybe empty string in an error case
	 */
	static getThumbUrl(appConfig, storage, id, thumbQuality = ''){
		if(storage.proxyCacheController){
			const defaultThumbQuality = ((((appConfig || {}).proxyCaches || {}).services || {}).youtube || {}).defaultThumbQuality || '';
			thumbQuality = String(thumbQuality).trim() || defaultThumbQuality
			return storage.proxyCacheController.getUrl('youtube', {
				url: `https://img.youtube.com/vi/${id}/${thumbQuality}.jpg`,
				extension: 'jpg',
				name: `${id}_${thumbQuality}`,
			})
		}

		return ''
	}

	/**
	 * returns the internal proxy cache details according to the given parameters.
	 *
	 * @param appConfig    		object - actual appConfig
	 * @param storage       	object - actual storage
	 * @param videoUrl			string - youtube videoUrl
	 * @param [thumbQuality]    string - thumb quality - default is set via serverAppConfig.proxyCaches.services.youtube.defaultThumbQuality
	 * @return {object}			detailed parameters of the video e.g., {id,url,thumb,watchUrl,embedUrl,shortsUrl}
	 */
	static getDetailsByUrl(appConfig, storage, videoUrl, thumbQuality = ''){
		const embedUrl	= 'https://www.youtube.com/embed/';
		const watchUrl	= 'https://www.youtube.com/watch?v=';
		const shortsUrl	= 'https://youtube.com/shorts/';
		let id;
		let url = videoUrl;
		let thumb;

		// videoUrl is not an embed url of youtube
		if (videoUrl.indexOf(embedUrl) === -1) {
			if (videoUrl.indexOf(watchUrl) >= 0) {    // https://www.youtube.com/watch?v=_3QfWLRPnrs
				id = videoUrl.split('=').pop();
			}
			else if (videoUrl.indexOf(shortsUrl) >= 0) {    // https://youtube.com/shorts/3QfWLRPnrs
				id = videoUrl.split('shorts/').pop();
			}
			else if (videoUrl.indexOf('https://youtu.be/') >= 0) { // https://www.youtube.com/watch?v=_3QfWLRPnrs
				id = videoUrl.split('be/').pop();
			}
			// videoID found
			if (id) {
				id = String(id).trim()
				// create an embed URL for the iframe
				url = 'https://www.youtube-nocookie.com/embed/' + id;
			}
		} else { // extract videoCode from embed url
			id = String(videoUrl.split('embed/').pop() || '').trim();
		}

		if(id){
			thumb = this.getThumbUrl(appConfig, storage, id, thumbQuality);
		}

		return {
			id,
			url,
			thumb,
			watchUrl: watchUrl + id,
			embedUrl: embedUrl + id
		}
	}
}

module.exports = Youtube